import { me } from '@connected/api-client/data/auth/me';
import { ContentLayout } from '@connected/ui/layouts/content/layout';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/admin')({
    beforeLoad: async ({ context }) => {
        const user = await context.queryClient.ensureQueryData(me.queryOptions());

        if (!user || user.IsAdmin !== true) {
            throw redirect({
                to: '/',
            });
        }
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <ContentLayout className="w-full gap-0">
            <ContentLayout.Header className="py-5">
                <ContentLayout.Title>Admin</ContentLayout.Title>
            </ContentLayout.Header>
            <ContentLayout.Outlet />
        </ContentLayout>
    );
}
